import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  headerView: {
    borderBottomWidth: 0,
  },
  contentView: {
    paddingLeft: 20,
    paddingRight: 20,
  },
});
